import { CurrencyInput, CurrencyMinor, FormRadio, MuiRadioGroup, Typography, toCents, toCurrency } from '@fox/atoms';
import { SpaceBetweenRow } from '@fox/layout';
import { useEffect } from 'react';
import { useFinancialContext } from '../../../financial-config-context';
import { Fee, FeesSelection } from '../contracts';
import { FRIENDLY_INTERVAL, INTERVAL_SHORT, formatCurrency } from '../shared';

export function FeeSelection({ fee }: { fee: Pick<Fee, 'interval' | 'units'> }) {
	if (fee.units > 0) {
		return (
			<>
				{fee.units} {INTERVAL_SHORT[fee.interval]}s
			</>
		);
	}

	return <>{FRIENDLY_INTERVAL[fee.interval]}</>;
}

export function FeeSelector({
	fees,
	defaultValue,
	onChange,
	nominatedFee,
	updateNominatedFee,
	allowNominated
}: {
	fees: FeesSelection[];
	defaultValue: string | null;
	onChange: (feeId: string) => void;
	updateNominatedFee: (nominatedFee: CurrencyMinor) => void;
	nominatedFee?: CurrencyMinor;
	allowNominated?: boolean;
}) {
	const { currencies } = useFinancialContext();
	//should just list all the fees that are part of the plan
	const firstFee = fees?.[0]?.id;
	const singleFeeId = fees.length === 1 ? firstFee : null;

	useEffect(() => {
		if (singleFeeId && firstFee) {
			onChange(firstFee);
		}
	}, [singleFeeId, firstFee]);

	return (
		<>
			<MuiRadioGroup
				value={defaultValue ?? null}
				onChange={(event, value) => {
					onChange(value);
				}}
			>
				{fees.map((fee, idx) => {
					return (
						<SpaceBetweenRow key={idx}>
							<FormRadio value={fee.id}>
								<FeeSelection fee={fee} />
							</FormRadio>
							{!allowNominated ? (
								<Typography>{formatCurrency(fee.fee, fee.currency ?? currencies.default)}</Typography>
							) : null}
						</SpaceBetweenRow>
					);
				})}
			</MuiRadioGroup>
			{allowNominated ? (
				<CurrencyInput label="Amount" fullWidth amount={toCurrency(nominatedFee)} setAmount={v => updateNominatedFee(toCents(v))} />
			) : null}
		</>
	);
}
